// extracted by mini-css-extract-plugin
export default {"content":"CustomerDetailsSummaryCard_content__dlwNZ","buttons":"CustomerDetailsSummaryCard_buttons__nK4D4"};